import React from 'react';

import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import { MODAL_SIZE_OPTIONS } from 'src/constants/constants';

interface Props {
  workflowId: string,
  perspectiveId: string,
  onSuccess: () => void,
}

const PerspectiveDetails = ({
  workflowId,
  perspectiveId,
  onSuccess,
}: Props) => {
  const fieldsConfig = [
    {
      name: 'name',
      component: () => (
        <FormikInput
          fullWidth
          label="Title"
          name="name"
        />
      ),
    },
    {
      name: 'width',
      component: () => (
        <FormikSelect
          label="Width"
          name="width"
          fullWidth
          options={MODAL_SIZE_OPTIONS}
        />
      ),
    },
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/workflows/${workflowId}/perspectives/`}
      objectId={perspectiveId}
      onSuccess={onSuccess}
      fieldsConfig={fieldsConfig}
      autoSave
    />
  );
};

export default PerspectiveDetails;
